import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.machines_monitoring_page', () => {
  import('./internal/machines_monitoring_page').then(({ default: Component }) => Component());
});
